import React from 'react'
import '../../styles/admission/main.css';

const Main = () => {
  return (
    <div className="admission-registration">
      <div className="container main-box">
        <div className="box">
          <div className="col-lg-4 col-sm-12">
            <div className="image">
              <span>Admission/ registration</span>
              <img src="../assets/images/admission-back.jpg" alt="" />
            </div>
          </div>
          <div className="col-lg-8 col-sm-12">
            <div className="links">

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://ccsuniversityadm.samarth.edu.in/" target="blank">
                    <p>
                      CAMPUS / COLLEGE Registration Form 2026-27 (UG/PG/Certificate/Diploma/PG Diploma)<span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/05/CCSU_ADMISSION_2026-27.pdf" target="blank">
                    <p style={{color: "red"}}>
                      Steps for New Registration for Admissions 2026-27 <span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/08/ADMISSION%20PROCESS%202026-27%20CATALOGUE%20FOR%20UNIVERSITY%20CAMPUS_final_1.pdf" target="blank">
                    <p style={{color: "black"}}>
                      Admission Process 2026-27 Catalogue for University Campus <span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/08/ADMISSION%20PROCESS%202026-27%20CATALOGUE%20FOR%20AFFILATED%20COLLEGES%20through%20SAMARTH_final.pdf" target="blank">
                    <p style={{color: "black"}}>
                      Admission Process 2026-27 Catalogue for Affiliated Colleges <span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div>

               <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://minority.ccsuforms.in/" target="blank">
                    <p>
                      Admission Registration link for the B.Ed. Minority<span id="new-blink">new</span></p>
                  </a>
                </div>
              </div>
              
              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://entrance.ccsuforms.in/" target="blank">
                    <p>
                      Registration/ Application form for Admission through Entrance Test in University Campus & Affiliated Colleges 2026-2027 (M.Ed., B.P.Ed., M.P.Ed., and LL.M)<span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/ITEP_Information_Brochure_2025-26.pdf" target="blank">
                    <p>
                      ITEP Information Brochure 2026-27<span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="http://itep.ccsuforms.in/" target="blank">
                    <p>
                      Registration for ITEP (B.A.B.Ed. and B.Sc. B.Ed)<span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/ITEP%20(B.A.B.Ed.%20and%20B.Sc.B.Ed.%20Secondary)%20First%20Merit%20List%20(Provisional).pdf" target="blank">
                    <p>
                      ITEP (B.A.B.Ed. and B.Sc.B.Ed. Secondary) First Merit List (Provisional)<span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/07/itep%20second%20merit.pdf" target="blank">
                    <p>
                      ITEP (B.A.B.Ed. and B.Sc.B.Ed. Secondary) Second Merit List (Provisional)<span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div>

               {/* <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://ccsuniversityweb.in/" target="blank">
                    <p>
                      Registration for admission in PG Diploma in Cyber Crime and Law<span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div> */}
              

              {/* <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://minority.ccsuforms.in/" target="blank">
                    <p>
                      Application Form for Admission in Minority Colleges / Institution : 2025-26<span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div> */}

              {/* <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://entrance.ccsuforms.in/llmmerit/" target="blank">
                    <p>
                      L.L.M Second Merit 2025-26<span id="new-blink">new</span>
                    </p>
                  </a>
                </div>
              </div> */}

              
              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/06/University%20Campus%20Admission%20Brochure%20(2026-27)%20Updated%200n%2018-06-2026.pdf" target="blank">
                    <p>University Campus Admission Brochure 2026-2027<span id="new-blink">new</span></p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2026/09/College%20Admission%20Brochure-2026_compressed.pdf" target="blank">
                    <p>College Admission Brochure 2026-2027<span id="new-blink">new</span></p>
                  </a>
                </div>
              </div>


              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="http://scriet.ccsuforms.in/" target="blank">
                    <p>Registration Form for B.Tech., M.C.A., M.B.A., and M.Tech. 2026-2027</p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/05/Anti-Ragging%20Undertaking.pdf" target="blank">
                    <p>Anti-Ragging Undertaking</p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://cdn.ccsuniversity.ac.in/public/pdf/2025/05/Pradhan%20Mantri%20Vidyalaxmi%20Scheme.pdf" target="blank">
                    <p>Pradhan Mantri Vidyalaxmi Scheme</p>
                  </a>
                </div>
              </div>

              <div className="link">
                <span><img src="../assets/images/link.svg" alt="" /></span>
                <div className="content">
                  <a href="https://phdadmission.ccsuforms.in/" target="blank">
                    <p>Application  Form For Ph.D. Admission</p>
                  </a>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Main;